// Copy for the per-bus warning callouts, shared between the map's bus
// detail pane (BusDetailPane) and the bus details page
// (BusGeneralInfoSection) so the two surfaces never drift apart.
//
// TODO: Consolidate these into full shared callout definitions
// (trigger condition + copy + intent in one list) that both surfaces
// render from, so a future message added here automatically shows on
// the bus details page. Kept as copy-only constants for now to avoid
// refactoring BusDetailPane right before the bus page launch.

export const RTOE_CALLOUT_TITLE = "Now part of SPP (RTOE)";
export const RTOE_CALLOUT_BODY =
    "This bus belongs to an entity that is now part of SPP through RTO Expansion (RTOE).";

export const LOW_CONFIDENCE_LOCATION_CALLOUT_TITLE =
    "Coordinates may be inaccurate";
export const LOW_CONFIDENCE_LOCATION_CALLOUT_BODY =
    "Nira has low confidence on the coordinates for this bus. Please double-check the location in other data sources.";
